import Model from "../../core/model/Model";
import { INameTranslation } from "../../core/model/translations/NameTranslation";
import ValidatableObject from "../../core/model/validation/ValidatableObject";
import { IIndexType } from "../../indexTypes/model/IndexType";
import { IOrganisationIndexGroup } from "./OrganisationIndexGroup";

export interface TOrganisationIndex {
  id: number;
  name: string;
  indexTypeId: number;
  organisationId: number;
  organisationGroupId: number;
  indexIds: string;
  groups: IOrganisationIndexGroup[];
  valid: boolean;
  harmonized: boolean;
  pathToIndex: string[];
  nameTranslations: INameTranslation[];
}

export interface IOrganisationIndex extends TOrganisationIndex {
  type?: IIndexType;
  contains(criteria: string): boolean;
}

const OrganisationIndex = Model(
  (model: TOrganisationIndex): IOrganisationIndex => {
    const _value: TOrganisationIndex = Object.assign({}, model);
    let _type: IIndexType;
    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get name() {
        return _value.name;
      },
      set name(value) {
        _value.name = value;
      },
      get indexTypeId() {
        return _value.indexTypeId;
      },
      set indexTypeId(value) {
        _value.indexTypeId = value;
      },
      get organisationId() {
        return _value.organisationId;
      },
      set organisationId(value) {
        _value.organisationId = value;
      },
      get organisationGroupId() {
        return _value.organisationGroupId;
      },
      set organisationGroupId(value) {
        _value.organisationGroupId = value;
      },
      get groups() {
        return _value.groups;
      },
      set groups(value) {
        _value.groups = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      },
      get harmonized() {
        return _value.harmonized;
      },
      set harmonized(value) {
        _value.harmonized = value;
      },
      get indexIds() {
        return _value.indexIds;
      },
      set indexIds(value) {
        _value.indexIds = value;
      },
      get pathToIndex() {
        return _value.pathToIndex;
      },
      set pathToIndex(value) {
        _value.pathToIndex = value;
      },
      get nameTranslations() {
        return _value.nameTranslations;
      },
      set nameTranslations(value) {
        _value.nameTranslations = value;
      },
      get type() {
        return _type;
      },
      set type(value) {
        _type = value;
      },
      contains(criteria: string) {
        return (
          _value.name.toLowerCase().indexOf(criteria.toLowerCase()) !== -1 ||
          _value.nameTranslations.some(
            (item) =>
              item.nameTranslation
                .toLowerCase()
                .indexOf(criteria.toLowerCase()) !== -1
          )
        );
      }
    };

    return ValidatableObject<IOrganisationIndex>(_model);
  }
);

export default OrganisationIndex;
